import { render, staticRenderFns } from "./setting-main.vue?vue&type=template&id=564ff3b5&scoped=true&"
import script from "./setting-main.vue?vue&type=script&lang=js&"
export * from "./setting-main.vue?vue&type=script&lang=js&"
import style0 from "./setting-main.vue?vue&type=style&index=0&id=564ff3b5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564ff3b5",
  null
  
)

export default component.exports